import request from '@/utils/request'
import qs from 'qs'
// 复制监控
export function copyRecord (params) {
  return request({
    url: '/business/operation/record',
    method: 'post',

    data: params
  })
}
export function getPhoneCode (params) {
  return request({
    url: '/public/phoneCode',
    method: 'get'
  })
}
// 手机号+密码登录
export function pwLogin (params) {
  return request({
    url: '/sms/pwLogin',
    method: 'post',

    data: params
  })
}
// 手机号+验证码重置密码
export function resetpw (params) {
  return request({
    url: '/sms/resetpw',
    method: 'post',

    data: params
  })
}
// 手机号验证码
export function getPhoneKeyCode (params) {
  return request({
    url: '/sms/code',
    method: 'post',

    data: params
  })
}
// 手机号验证码登录
export function keyCodeLogin (params) {
  return request({
    url: '/sms/login',
    method: 'post',

    data: params
  })
}
// 邮箱重置密码
export function resetpwEmail (params) {
  return request({
    url: '/email/resetpw',
    method: 'post',

    data: params
  })
}
// 邮箱密码登录
export function pwLoginEmail (params) {
  return request({
    url: '/email/pwLogin',
    method: 'post',

    data: params
  })
}
// 手机号注册
export function registerPhone (params) {
  return request({
    url: '/sms/register',
    method: 'post',

    data: params
  })
}
// 邮箱获取验证码
export function registerEmailCode (params) {
  return request({
    url: '/email/code',
    method: 'post',

    data: params
  })
}
// 邮箱注册
export function registerEmail (params) {
  return request({
    url: '/email/register',
    method: 'post',

    data: params
  })
}
// 机构账号密码登录
export function pwLoginJG (params) {
  return request({
    url: '/jg/pwLogin',
    method: 'post',

    data: params
  })
}
// 搜索
export function essearch (params) {
  return request({
    url: '/search/bookList',
    method: 'post',

    data: params
  })
}

// 阅读记录
export function readHistory (params) {
  return request({
    url: 'business/read/list',
    method: 'get',

    params
  })
}
// ip登录信息
export function isCompanyUser (params) {
  return request({
    url: '/common/isCompanyUser',
    method: 'get',

    params
  })
}
// 字典
export function getDictType (params) {
  return request({
    url: '/public/dict/type/' + params.dictType,
    method: 'get'
  })
}
// 书籍树形结构
export function booksTree (params) {
  return request({
    url:
      '/business/book/treeNode?parentId=' +
      params.parentId +
      '&nodeType=' +
      params.nodeType +
      (params.keyword ? '&keyword=' + params.keyword : ''),
    method: 'get',
    headers: {
      'Content-Type': 'application/json'
    },
    token: true
  })
}

export function treeNodeList (params) {
  return request({
    url: '/business/book/treeNodeList',
    params: params,
    method: 'get'
  })
}
// 获取文章列表
export function getArticleList (params) {
  return request({
    url: '/public/articleList',
    method: 'get',
    params: params || {}
  })
}

export function getArticleDetail (params) {
  return request({
    url: '/public/article/id/' + params,
    method: 'get'
  })
}
export function getArticleDetailByName (params) {
  return request({
    url: '/public/article/' + params,
    method: 'get'
  })
}
// 书籍详情
export function bookInfo (params) {
  return request({
    url: '/business/book/bookInfo/' + params.bookId,
    method: 'get',
    token: true
  })
}
// 书页信息
export function bookPage (params) {
  return request({
    url: '/business/book/bookPage',
    method: 'get',
    params: params,
    token: true
  })
}

// 阅读记录
export function read (params) {
  return request({
    url: '/business/read',
    method: 'post',
    data: params,
    token: true
  })
}
// 手机验证码登录
export function getCaptchaImg (params) {
  return request({
    url: '/captchaImage',
    method: 'get',
    data: params
  })
}
// 微信登录
export function wxLogin (params) {
  return request({
    url: '/wx/login',
    method: 'post',
    data: params
  })
}
// 稻壳登录
export function dkLogin (params) {
  return request({
    url: '/daoke/login',
    method: 'post',
    data: params
  })
}
// 手机验证码登录
export function smsLogin (params) {
  return request({
    url: '/sms/login',
    method: 'post',
    data: params
  })
}
// 绑定手机号
export function changeMobile (params) {
  return request({
    url: '/business/user/changeMobile',
    method: 'post',
    data: params
  })
}

// 获取手机验证码
export function smsCode (params) {
  return request({
    url: '/sms/code',
    method: 'post',
    data: params
  })
}

export function feedbackAdd (params) {
  return request({
    url: '/business/feedback/add',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params: params,
    token: true
  })
}

export function getInfo (params) {
  return request({
    url: '/business/user/getInfo',
    method: 'get',
    // headers: {
    //   "Content-Type": "application/x-www-form-urlencoded"
    // },
    params: params
    // token: true
  })
}

// ruzang
export function getBookList (params) {
  return request({
    url: '/business/book/list',
    // method: '',
    params
  })
}

export function getBookDetail (params) {
  return request({
    url: '/business/book/bookInfo/' + params
  })
}
// 新增目录接口
export function getCatalogImages (params) {
  return request({
    url: 'business/book/catalogImages/' + params
  })
}

// 新增pdf接口
export function getPdfImages (params) {
  return request({
    url: 'business/book/pdfImages/' + params
  })
}

export function getBookContent (params) {
  return request({
    url: '/business/book/bookPage',
    // method: '',
    params
  })
}

export function getBookContentInSearch (params) {
  return request({
    url: '/search/pageJump',
    method: 'post',
    data: params
  })
}

export function getBookCatalogue (params) {
  return request({
    url: '/business/book/catalogNode',
    // method: '',
    params
  })
}

export function addBookNote (params) {
  return request({
    url: '/business/note/add',
    method: 'post',
    data: params
  })
}

export function editBookNote (params) {
  return request({
    url: '/business/note/edit',
    method: 'post',
    data: params
  })
}

// export function editBookQa (params) {
//   return request({
//     url: "/business/feedback/edit",
//     method: "post",
//     data: params
//   })
// }

export function addBookQa (params) {
  return request({
    url: '/business/feedback/add',
    method: 'post',
    data: params
  })
}

export function getBookQaList (params) {
  return request({
    url: '/business/feedback/list',
    method: 'get',
    params
  })
}

export function deleteBookQaList (id) {
  return request({
    url: '/business/feedback/' + id,
    method: 'DELETE'
  })
}

export function getBookNoteList (params) {
  return request({
    url: '/business/note/list',
    method: 'get',
    params: params
  })
}

export function searchWordInBook (params) {
  return request({
    url: '/business/search',
    method: 'get',
    params: params
  })
}

export function getBookNum (params) {
  return request({
    url: '/search/booknum',
    method: 'get',
    params: params
  })
}

export function getNoteSum (params) {
  return request({
    url: '/search/noteSum',
    method: 'get',

    params: params
  })
}

export function getMainSum (params) {
  return request({
    url: '/search/mainSum',
    method: 'get',

    params: params
  })
}

export function getWriterList (params) {
  return request({
    url: '/search/writerList',
    method: 'get',

    params: params
  })
}

export function newGetWriterList (params) {
  return request({
    url: '/business/book/search/writer/list',
    method: 'get',

    params: params
  })
}

export function getDynastyList (params) {
  return request({
    url: '/search/dynastyList',
    method: 'get',

    params: params
  })
}

export function getCategoryNode (params) {
  return request({
    url: '/search/categoryNode?parentId=0',
    method: 'get',

    params: params
  })
}

export function newGetCategoryNode (params) {
  return request({
    url: '/business/book/search/category/list',
    method: 'get',

    params: params
  })
}

export function getSearchDetail (params) {
  return request({
    url: '/search/pageDetail',
    method: 'get',

    params: params
  })
}

// 我的
export function getNoteList (params) {
  return request({
    url: '/business/note/listSummary',
    method: 'get',

    params: params
  })
}
export function getNoteListNew (params) {
  return request({
    url: '/business/note/list',
    method: 'get',

    params: params
  })
}

export function deletBookNote (params) {
  return request({
    url: '/business/note/delete/' + params.noteId,
    method: 'DELETE'
    // params: params
  })
}
export function getFavorStatus (params) {
  return request({
    url: '/business/favor/isFavor/' + params,
    method: 'get'
  })
}
export function addFavordData (params) {
  return request({
    url: '/business/favor/add',
    method: 'post',
    data: params
  })
}
export function getFavordData (params) {
  return request({
    url: '/business/favor/list',
    method: 'get',
    params: params
  })
}

export function deleteFavor (params) {
  return request({
    url: '/business/favor/delete/' + params,
    method: 'DELETE'
    // params: params
  })
}

export function deleteRead (params) {
  return request({
    url: '/business/read/deleteByBookId/' + params,
    method: 'DELETE'
    // params: params
  })
}

export function addRead (params) {
  return request({
    url: '/business/read',
    method: 'post',
    data: params
  })
}
// 操作记录
export function addLatest (params) {
  return request({
    url: '/business/latest',
    method: 'post',
    data: params
  })
}

export function getLatestList (params) {
  return request({
    url: '/business/latest/list',
    method: 'get',
    params
  })
}

export function getReadList (params) {
  return request({
    url: '/business/read/list',
    method: 'get',
    params
    // responseType: 'blob'
  })
}
export function exportSearchResult (params) {
  return request({
    url: '/search/exportSearchResult',
    method: 'post',
    data: params,
    responseType: 'blob'
  })
}

export function exportNotes (params = {}) {
  return request({
    url: '/business/note/export',
    method: 'post',
    data: params,
    responseType: 'blob'
  })
}

export function downloadBookFile () {
  return request({
    url: '/public/downloadBookFile',
    // method: "post",
    responseType: 'blob',
    headers: {
      'retheader': true
    }
  })
}
export function deleteNotesByBook (params) {
  return request({
    url: '/business/note/deleteByBookId',
    method: 'DELETE',
    params
  })
}

//  新增搜索条件空置复选框多选

export function getlistByIdsApi (params) {
  return request({
    url: '/business/book/listByIds',
    // method: "get",
    params
  })
}

export function getHitCount (params) {
  return request({
    url: '/search/hitCount',
    method: 'post',
    data: params
  })
}

// 繁体字表缓存

export function getHanMap () {
  return request({
    url: '/search/hanMap',
    method: 'get'
  })
}

// 根据作者或者校点者获取书列表

export function getBookListByWriter (params) {
  return request({
    url: '/business/book/listByCon',
    method: 'get',
    params
  })
}

// 填写用户信息
export function updateBaseInfo (params) {
  return request({
    url: '/business/user/updateBaseInfo',
    method: 'post',
    data: params
  })
}

export function updateAvatar (params) {
  return request({
    url: '/business/user/updateAvatar',
    method: 'post',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    data: params
  })
}

// 下订单
export function getOrder (params) {
  return request({
    url: '/business/order/saveRankOrder',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: params
  })
}

// 预支付
export function getImgCode (params) {
  return request({
    url: '/business/order/pay',
    method: 'get',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    },
    params
  })
}

// 订单详情
export function orderDetail (orderId) {
  return request({
    url: '/business/order/' + orderId,
    method: 'get'
  })
}

// 卡列表
export function getRankList (params) {
  return request({
    url: '/public/rank/list',
    method: 'get',
    params
  })
}
// 订单列表/api-biz/business/order/list
export function orderList (params) {
  return request({
    url: '/business/order/list',
    method: 'get',
    params
  })
}
// 取消订单/api-biz/business/order/cancel/{orderId}
export function cancelOrder (orderId) {
  return request({
    url: '/business/order/cancel/' + orderId,
    method: 'put',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 开发票
export function addInvoice (params) {
  return request({
    url: '/business/invoice/apply',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: params
  })
}

// 接总平台
export function platformLogin (params) {
  return request({
    url: '/external/platform/login',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: params
  })
}

// 获取问题详情
export function getQaDetail (feedbackId) {
  return request({
    url: '/business/feedback/' + feedbackId,
    method: 'get'
  })
}
// 获取笔记详情
export function getNoteDetail (noteId) {
  return request({
    url: '/business/note/' + noteId,
    method: 'get'
  })
}

// 綁定集團卡

export function bindCardNo (cardNo) {
  return request({
    url: '/business/user/bindCardNo?cardNo=' + cardNo,
    method: 'put',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 查询书页列表
export function bookPageList (query) {
  return request({
    url: '/business/book/bookPageList',
    method: 'get',
    params: query
  })
}

// 查询项目详细
export function pageBoxInfo (pageId) {
  return request({
    url: '/business/book/pageBoxInfo/' + pageId,
    method: 'get'
  })
}
// 书单
export function getReadListNew (params) {
  return request({
    url: '/business/readinglist/list',
    method: 'get',

    params: params
  })
}

export function deleteReadList (id) {
  return request({
    url: '/business/readinglist/' + id,
    method: 'DELETE'
  })
}

// 添加书单
export function addShudan (params) {
  return request({
    url: '/business/readinglist/',
    method: 'post',
    headers: {
      'Content-Type': 'application/json'
    },
    data: params
  })
}

// 书单
export function readinglistBySearch (params) {
  return request({
    url: '/business/readinglist/search/list',
    method: 'get',

    params: params
  })
}
// 查询书目录
export function catalogList (query) {
  console.log('query', query)
  return request({
    url: '/business/book/catalogNode',
    method: 'get',
    params: query
  })
}
// 修改书单
export function editreadlist (params) {
  return request({
    url: '/business/readinglist/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json'
    },
    data: params
  })
}

// 书单详细
export function bookListInReadlist (query) {
  return request({
    url: '/business/readinglist/book/list',
    method: 'get',
    params: query
  })
}

// 朝代
export function getDynastyListNew (params) {
  return request({
    url: '/business/book/search/dynasty/list',
    method: 'get',

    params: params
  })
}
// 阅读页-获取本书页码
export function getBookPageInfoApi (query) {
  return request({
    url: '/business/book/bookPageInfo',
    method: 'post',
    data: query
  })
}

export function getReadSinglePage (query) {
  return request({
    url: '/business/book/singlePage',
    method: 'post',
    data: query
  })
}

// 删除书单书籍
export function delBookByReadList (query) {
  return request({
    url: '/business/readinglist/delBookIds',
    method: 'post',
    data: query
  })
}

// 首页书籍总数
export function getBookCount () {
  return request({
    url: '/search/bookCount',
    method: 'get',
  })
}



// WEBPACK FOOTER //
// ./src/api/api.js